module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "head",
    attrs: {
      "id": "Part1"
    }
  }, [_vm._v("Act One")]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('h3', {
    staticClass: "head2",
    attrs: {
      "id": "ch1"
    }
  }, [_vm._v("Act One "), _c('br'), _vm._v("SCENE ONE")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It is the living room of Wild Grove one autumn afternoon—if one were to describe the room in terms of its owner, H. C. Callifer, a high-minded rather pedantic room and a little outmoded. There are a lot of books, but they look, even from a distance, dull and heavy books. One might have taken them for works of theology if one were unaware of H. C. Callifer’s reputation. Alas! how much of the world, after a period when Callifer was classed with Wynwood Read and")]), _vm._v(" The Cosmic Fallacy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("with")]), _vm._v(" The Martyrdom of Man, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("has become unaware of that reputation. The world has changed around this room, this house. When Callifer first built Wild Grove, planning it with the woman he loved, those factory chimneys which now appear in the distance through the garden window did not exist. There")]), _vm._v(" was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a grove—perhaps there was even a wildness in Callifer himself, but more than forty years have passed since then. The Grove has become a grave, and in the best bedroom upstairs H. C. Callifer is dying. Throughout the scene that follows, till the very end, we hear at times the footsteps of those above; conversations are interrupted while the quality of the footsteps are, as it were, assessed.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-13"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("When the curtain rises there is only one occupant of the living room—a man twenty years junior to Callifer himself, but twenty years at this period of life have ceased to count. Dr. Frederick Baston is now well past sixty, though he was once Callifer’s youngest and cleverest disciple. His reputation grew with Callifer’s, but he was never a rival. If Callifer had died at sixty, Baston would have written his biography and carried on his work, but when the tide of the world’s favour receded from Callifer, it receded from Baston too. They are part of the same beach. Will any publisher now be sufficiently interested to commission a biography?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A small, tired, fussy figure, worrying too much about details, Baston is walking restlessly from one end of the living room to the other, from the fireplace with Dutch tiles to the mirror over the sofa. He carries two or three sheets of notepaper in his hand and he is learning something by heart. As he reaches the fireplace he tries out a passage, letting his hand fall.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": It needed courage in those days to meet the challenge of the churches with a—with a"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("—(he consults his pages again and walks back towards the mirror, reading the words in an inaudible mutter. When he reaches the mirror he shoots out another phrase)—")]), _vm._v("against the vested interests of superstition. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(He catches sight of himself in the mirror and, leaning forward, examines a sty on the lower lid of his left eye. He gives it a tentative squeeze, and then starts out on his walk again.) ")]), _vm._v("Callifer’s greatest book was of course "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Cosmic Fallacy, ")]), _vm._v("but those who were closest to him knew what store he set by that charming pathetic study of Jesus Christ, the Palestinian religious leader, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He Was a Man.")]), _vm._v(" He was a man. We can say that too, in a different sense, of Callifer. Those of us who loved him most, his wife, his sons—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(he consults his pages)")]), _vm._v(" his son, his oldest friend and disciple, repeat with sorrow, “He was a man.” We would be unworthy of him—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(he reaches the mirror and again against his will his finger goes up and tries the sty; a pause; he turns to pace again; a girl of thirteen comes through the garden window, unnoticed, and watches him)")]), _vm._v(" unworthy of him if, if—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(he consults his pages, looks around, picks up an ash-tray from a table)")]), _vm._v(" we did not recognize that these ashes that at his request I now resign to the river and the fields and the earth he loved "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(he makes a motion with his ash-tray)")]), _vm._v(" are all that remains. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Back again, while the girl observes him.)")]), _vm._v(" Now that the immense spaces of the empty universe, of uninhabited planets and cooling stellar systems have taken the place of the Christian God, we have Callifer to thank for a human life worthy of courageous Man. To the Christian superstition of eternal life, he bravely countered with the truth, Eternal Death.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The girl interrupts, interested, matter-of-fact.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Has Grandfather died, Dr. Baston?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(put out)")]), _vm._v(": I’m sorry—didn’t hear. … Where did you come from?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": The garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Playing?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Would you mind being very careful what questions you ask me?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Why?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-15"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": There you go again. You see, I’ve made a vow that for one month I’ll speak the exact truth—a lunar month, not a calendar. There are still eighteen days to go.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": What happens afterwards?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": I shall tell lies again like everybody else. Is Grandfather dead yet?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": He’s making a wonderful fight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": So would you, wouldn’t you? It can’t be very nice, being dead. Is Granny with him?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Yes. And your father. And the doctor, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Will he last the night, do you think?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": So "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" ask questions too.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Only when I really want to know the answer. Practical questions. That was another vow of mine. Only I’m keeping that vow forever.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Who did you vow to?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": To the inevitability of evolution and the sacredness of man.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": It sounds a big vow.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": I got it from an essay of grandfather’s, “The Credo of an Atheist.” You know, I liked what you said just now about uninhabited planets.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": I can see you’re a real Callifer.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-16"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Sometimes I wish this planet was uninhabited too—no human beings, only hills and rivers and sky.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": I rather like human beings.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": I don’t. They are so untidy. Stomach aches, colds in the head, spots—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(")]), _vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("automatically puts up his hand to his sty.)")]), _vm._v("  Aunt Sara’s in the garden, snivelling in a deck chair.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": What a hard child you are.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": It’s no good being mushy, is it? It’s the truth that matters. And she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v("  snivelling.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": You could have said “crying.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": But crying’s quite a different thing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": I expect she’s very fond of your grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Perhaps. Or she may be snivelling for lost love, though it’s not likely after all these years. I call her Aunt Sara, but strictly speaking I shouldn’t, should I, not after she divorced Uncle?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(ironically)")]), _vm._v(":  A courtesy title.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": I don’t understand why she comes here, and not Uncle James.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(uneasily)")]), _vm._v(":  I suppose he was too busy to come. Or perhaps his paper couldn’t spare him. And it’s a long way from Nottingham.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": My school is further than Nottingham. They fetched"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" me.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": I expect there was some reason.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-17"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": They never told him Grandfather was dying.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Nonsense.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": But I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("know.")]), _vm._v(" They gave me the telegrams to take to the post office. There was one to you and one to Father, even one to her. but not to him. Is he a criminal? That’s a practical question.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Of course he isn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Or wicked?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": No, no.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Or mad?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Of course not.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" (after a pause for thought)")]), _vm._v(": Then I was quite right to do what I did.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": What did you do?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": I sent him a telegram myself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" (in a shocked voice)")]), _vm._v(": That was very, very wrong of you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Why?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": To upset everybody at a time like this. With your grandfather dying upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Is Uncle a hunchback? Has he got a face of horror?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": You’re a silly interfering little girl. I only hope he has the sense not to come. I shall have to warn your grandmother.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-18"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(pondering the word)")]), _vm._v(": Warn—?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": He’s not wanted here. Nobody wants him here.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(going thoughtfully to the window)")]), _vm._v(": I see. I’m sorry. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She goes thoughtfully out through the french windows, passing Sara as she does so.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sara is a woman of about thirty-six, good-looking, but carrying with her a sense of disappointment and drift.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(holding out his sheaf of papers)")]), _vm._v(": She’s made me forget every word. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(He lays the papers on a table.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Is he dead?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": No. They’ll call us at the end. Do you know what that child has done? She’s sent for James.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Poor James. But is that so awful? He’s got the right, hasn’t he?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": And that old man has the right to die in peace.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Sometimes the dying want to forgive …")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" (evasively)")]), _vm._v(": Oh, I don’t think there’s anything to forgive.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": It will be strange seeing James after all these years. What does a man become when a wife leaves him on his own? He ate salt on his bread and he used to take tea, not coffee, for breakfast. Those are the things one remembers. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(A pause.) ")]), _vm._v("Why did they always hate him so? I don’t.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-19"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" (hedging)")]), _vm._v(": It’s not hate. They never got along, that’s all. Even when he was a boy …")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": I would have loved a child of mine whatever he did. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(A pause.)")]), _vm._v(" Do you know, they only got fond of me after the divorce? They wrote to me so kindly then. But as long as James and I were together I was infectious. A mother generally defends her son, doesn’t she?—but when I left him, I won his mother’s approval.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": I shan’t tell Mrs. Callifer yet. Perhaps he’ll have the sense to keep away. For your sake, too, it would be painful.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Would it? I suppose so. It’s very bitter when a man leaves you for nothing. I wouldn’t have minded so much if he’d been in love with another woman. I could bear being beaten by someone younger, someone lovely. But I was beaten by a bed-sitting-room in Nottingham. That’s all he left me for.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": I remember your house at Richmond. It was very beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": But he wouldn’t live in it. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Bitterly)")]), _vm._v(": It contained "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": I never understood it. He always seemed so fond of you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Do you know what it’s like being married to a sleepwalker?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": I don’t know anything about marriage. I never had the nerve to commit it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-20"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v(" The door opens and Mrs. Callifer enters—a handsome upright figure in spite of her seventy years.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": How is he?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": He’s sleeping again. He was conscious for nearly five minutes. I almost hoped.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": You ought to rest, Mary. Let Sara or me—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I’ll rest when it’s over.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": You’re killing yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Oh, no, Fred, don’t worry. That would be too good. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(A pause.)")]), _vm._v(" Next week we would have had our golden wedding. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She goes over to a table where Baston has laid down his papers. Before he can interfere she has picked one up. He waits with a look of embarrassed shame.) ")]), _vm._v("It reads very well, Fred. “Cooling stellar systems.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Those are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" words.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": We had a royalty statement last week. They only send them once a year now. They’d sold three copies of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" The Cosmic Fallacy")]), _vm._v(" for export.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Anyway it’s in print still.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Oh, yes. At that rate it will be in print longer than we shall be. Christianity is the fashion now.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": A passing fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Of course. But how he hated those sentimental myths, virgin births, crucified Gods. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She is thinking of something else and talks to distract herself.)")]), _vm._v(" Just now, from Henry’s room, I thought I heard a dog barking. Did you?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": No. Perhaps a stray—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I must remember to look at the wire netting on the gate. We had a lot of trouble once with dogs, messing up the flower beds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" (with a smile)")]), _vm._v(": I have one now, but I never bring it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": You think I’m very fussy, but you know it’s not old age. I’ve always detested dogs, haven’t I, Fred?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Always.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Parodies of men and women. I hate parodies. We both always hated parodies. Where’s John?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": I thought he was with you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": He went to the post office.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I hope he won’t be long. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She tries to talk very detachedly and sensibly, but she can’t prevent her restless movements and the quick changes of subject that show her mind is elsewhere.)")]), _vm._v(" It was good of you to do the flowers, Sara. Very nicely, too. Perhaps a little modern. I’m surprised "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Times")]), _vm._v(" hasn’t rung up.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" (comfortingly)")]), _vm._v(": The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rationalist Review")]), _vm._v(" was on the telephone an hour ago. A Mr. Minster. He was very concerned.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" (dismissing the comfort)")]), _vm._v(": We never thought very highly of Mr. Minster. Where is Anne?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": In the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": If he becomes conscious it will be the last time. I do want him to see all the faces he loved. You, Fred, especially. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(But this statement is too near the emotion she is trying to suppress. She veers away")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("picking up Baston’s papers.)")]), _vm._v(" It was good of you to come at once, take all this trouble. You know I tried to persuade him to alter his will—about the ceremony. The River Wandle is not how he remembers it. Too much pollution from the dye factory, and the housing development has ruined the fields.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": John and I found a spot where you can only just see the chimneys—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Well, of course it doesn’t matter, does it? It’s just a gesture, scattering ashes. People are so sentimental sometimes—about death—wishing to be buried together.  "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Her voice breaks and she makes for a flower vase and begins to rearrange it.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(breaking the silence)")]), _vm._v(": I really believe I did hear a dog.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I thought I’d have Mrs. Bentham in to make new slipcovers. These are really too old. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She desperately slides across the surface of the unfamiliar new life of a widow.)")]), _vm._v(" Do you really have to go next week, Sara?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Oh, I could always make an excuse.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I thought if you could stay a few more days—we might hire a car and go to the autumn flower show at Weston. I missed it last year when Henry was ill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Of course I’ll stay.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-23"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anne comes quietly and rather secretively in through the window. She slides to a chair and takes the first book to hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I do wish John would come back. I’d better get some patterns to show Mrs. Bentham.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": I’ll write for you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Why, Anne, I didn’t see you come in. Where have you been?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(carefully)")]), _vm._v(": In the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(trying to be breezy)")]), _vm._v(": Playing?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(giving him a withering look—questions again)")]), _vm._v(": No.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Anne, that’s not the way to speak to Dr. Baston. He only wanted to know what you were doing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anne scowls into her book.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": You haven’t been picking flowers again, dear, have you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": No, Granny. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She takes the book and tries to escape, but something in her manner attracts attention.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS")]), _vm._v(". C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Where have you been, dear?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": It’s not fair, all of you asking questions. I told you my vow. You oughtn’t to ask any questions till the vow’s over.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": All the same, I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" asking, Anne.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(sullenly)")]), _vm._v(": I’ve been to the potting shed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A pause.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Oh. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(A pause.)")]), _vm._v(" Why the potting shed? You know I don’t like you going there. The gardener’s complained of you knocking over the seedlings.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": I didn’t touch them.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": What were you doing?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Oh, if you’ve got to know, I was shutting up a secret dog.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": A secret dog?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Then we did hear a bark.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Do you mean a stray dog?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": No. A secret dog.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": But you know I won’t have dogs here. Who does it belong to?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": A man.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": What man?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": He’s come to see Grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": I said, what man?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Well, if you must know, your ex-husband.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": James?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Did you know about this, Sara?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": Anne sent him a telegram.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Where is he?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNE")]), _vm._v(": I don’t know. I told him you didn’t like dogs. He’d forgotten. So he asked where he could put it, and I told him the potting shed. I said I’d show him the way, but he said I could do it for him. When I looked back, he’d gone. We’d meant to keep it a dark secret, but you would ask questions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("John, the eldest son, Anne’s father, enters through the left door. He is correctly dressed. He will only, in the event, need a black tie to be prepared for the funeral.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(": Mother, do you know who’s here?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": James.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(": I nearly ran into him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": If he’s here, well—of course—naturally—he’s welcome. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(James enters through the garden window. He is five years younger than John, who must be nearly fifty; in some ways he looks the elder. Life hasn’t dealt with him so well: he appears nervous and ill at ease, a stranger in his parents’ house. His clothes are less new and less suitable.)")]), _vm._v(" How are you, James? I’m glad you could come.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He kisses her cheek awkwardly. Then he sees Sara.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Sara "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(he makes an odd movement of apology),")]), _vm._v(" I didn’t mean to be a nuisance. I just thought if Father …")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Of course you’re not a nuisance. We telegraphed for you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anne looks up at this lie. ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-26"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Anne telegraphed for me "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(nodding at Anne).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I told her to, James.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Anne, with a flurry of anger, goes back into the garden.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": I see.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": This is Frederick Baston, James. You remember Dr. Baston.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": It’s so many years … "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(They shake hands with constraint.)")]), _vm._v(" How’s Father?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": It will be any moment now.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Can I see him?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Better not—at present. He’s unconscious.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("There is a pause. He stands there as though surrounded by strangers as ill-at-ease as himself. Then Sara breaks the circle and goes to his side.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": How are you, James?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Oh, well, very well, Sara. And you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Oh, I’m well, too.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(": How’s the paper, old man?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": That’s well. And the bank?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(": Oh—flourishing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTON")]), _vm._v(": How’s the weather up north?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": It was raining when I left.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A pause.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I must go to Henry. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She leaves the room.) ")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Well, let’s sit down.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(": If you don’t mind, I want to have a word with Fred—about the ceremony.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("John and Baston leave.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": The ceremony! What a cold word.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Dr. Baston is reading an oration. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She points to the table.)")]), _vm._v(" There it is.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": My mother didn’t even let me know.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": You heard what she said.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": It wasn’t true. I had the true story from Anne. I was to be left out. Why? One’s father’s death is usually supposed to be important.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Perhaps it’s not very important if you believe in nothing afterwards. Or do you? I ought to know. We were married for five years, but it’s the tea you had for breakfast I remember. You liked it strong. Otherwise you said you couldn’t taste it. Does your landlady make good tea?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": I suppose so. Sara, what’s wrong with me? Why do they keep me away? I wasn’t much of a husband to you, I know, but I wasn’t bad, was I?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": No. You weren’t bad, James. It was just you weren’t interested. You pretended very well and very kindly. Even in bed you pretended. I used to think there was another woman somewhere. Someone like the tea, strong enough for you to taste. You couldn’t taste me. What do you think about when you are alone?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Think about?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-28"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": I used to imagine you were thinking of someone else. But when you went away—there was nobody. How bored you must have been with me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": No, I wasn’t bored. I knew I made you unhappy. There seemed no point in going on. I wish you had married again, Sara. John’s a born widower, but you …")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": I took a lover after you went. He didn’t pretend. And then one night I woke and saw him sleeping beside me, content—and I remembered you with your eyes open, thinking of something else, and I didn’t want him any more. I didn’t love him any more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": What’s the good of talking importantly about love? It doesn’t last like a book or a tune. It goes out with the breath, and we can always snuff that out, can’t we? We’re not worth loving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Then nothing is.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": And I love nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(bitterly)")]), _vm._v(": You do indeed. In the night you’d wake loving Nothing. You went looking for Nothing everywhere. When you came in at night I could see you had been with Nothing all day. I was jealous of Nothing as though it was a woman; and now you sleep with Nothing every night. Oh hell, give me a cigarette.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-29"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": I don’t smoke. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Pause.)")]), _vm._v(" Sara, what’s wrong with me?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": You’re not alive. Sometimes I wanted to make you angry or sorry, to hurt you. But you never felt pain. Why did you marry me? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(James makes a gesture.)")]), _vm._v(" I believe it was curiosity to see if you could feel. You didn’t feel.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": I thought if I saw my father now, at the end, he’d tell me. Tell me what’s wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": I thought I knew what it was.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Yes?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": When your mother heard about the telegram she was afraid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Afraid of what I’d do?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Afraid of what you are.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": A middle-aged newspaper man. I go to the office at four and usually get away by one in the morning. I sleep till nine—I mean, I stay in bed. I take the dog for a walk in the park and have a meal with Corner.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Corner?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": He shares my lodgings—a reporter on the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Globe.")]), _vm._v(" My landlady has a penchant for tinned salmon. My dog likes it, but it often makes him sick. He’s not a very good dog—parents unknown.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-30"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": You shouldn’t have brought him here. Your mother hates dogs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Yes, I know. I forgot. You see, our acquaintance has not been very continuous.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Don’t be bitter. She’s very unhappy now.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": I’m not bitter. I want to know, that’s all. What’s your earliest memory, Sara?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": Driving a pony cart.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": I can remember nothing. Absolutely nothing. Until I was ill, just before they sent me away to school at fourteen. Lying in bed with a sore throat. A dim light burning, and a nurse—a very kind nurse, bringing me soup. I thought she was an angel—I’d seen a picture of one once, I suppose, in a shop.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": I’d come and live with you at Nottingham if you wanted me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": What about the house in Richmond?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": I’d sell it. I only came here because I thought I’d see you. But I didn’t dare to ask why you weren’t here. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(A slight pause.)")]), _vm._v(" You know, I love you, James.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Sara—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(He comes behind her and puts his hands over her eyes.)")]), _vm._v(" I could always talk to you better in the dark. Sara, I simply don’t know what love is. What is it?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": It’s what I feel now.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": But if I took my hands away and we saw each other, I’d see—a want. Isn’t there a love that just exists and doesn’t want? My father’s dying. He has nothing to hope for, any more, forever. When he looks at me, don’t you think I might see—just love? No claim, no hope, no want. Whisky taken neat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": The strong taste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Yes. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(He takes away his hands. The noise of feet on the ceiling above.)")]), _vm._v(" Listen. Perhaps he’s woken up. I haven’t seen him for fifteen years, Sara. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She puts her head against him.) ")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": How your heart’s beating!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Perhaps he’ll speak.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He moves a little towards the door. Mrs. Callifer’s voice calls from the stairs: “John! Fred!” The noise of quick footsteps, and Mrs. Callifer enters.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Where’s Anne?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARA")]), _vm._v(": In the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Please fetch her quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sara goes out into the garden.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Father?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Can I go up?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Please wait. The nurse has to let me know.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": There’s not much time, is there?")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-32"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": He mustn’t have a shock—now. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Sara comes in with Anne.)")]), _vm._v(" Go upstairs quickly, dear. Both of you. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She steps aside for them and they go out.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": I thought we had to wait for the nurse?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(slowly, bracing herself for the plain truth): ")]), _vm._v("James, I don’t want you to see him.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": But why? I’ve come for that.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I didn’t send the telegram.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": I know. I’m going to see him, though.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He moves towards the open door, but Mrs. Callifer shuts it and stands with her fingers on the handle.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I don’t want to be harsh. That’s why I wanted to let you know afterwards. But he’s got to die in peace.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Why should I destroy his peace?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" (pleadingly)")]), _vm._v(": I love him, James. I want so much to see the last of him. Promise me you won’t move from here.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": No! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(He shakes his head.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": Then I stay. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She leans wearily against the door.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Mother, if you love me—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS.")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALLIFER")]), _vm._v(": I love him more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMES")]), _vm._v(": Give me one reason. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(She doesn’t answer, but she is crying.)")]), _vm._v(" All right. You’ve won, Mother. I promise not to come.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-33"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As she goes through the door, the curtain begins slowly to fall on him alone, facing the door. He raises his head a little as though trying to hear the sounds overhead.")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("CURTAIN")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-34"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61051f82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter1.vue
// module id = 72
// module chunks = 0